export default {
    // getSomething: state => {
    //     return state.something;
    // }


    getQuery: state => {
        return state.query;
    },
    getDefaultQuery: state => {
        return state.defaultQuery;
    },
    getOffer: state => {
        return state.offer;
    },
    getFetchingRegions: state => state.fetchingRegions,
    getRegions: state => state.regions,
    getHouseTypes: state => state.houseTypes,
    getProperties: state => state.properties,
    getBookingRequestConfirmation: state => state.bookingRequestConfirmation,
    // TODO: remove this
    getLowestPrice: state => state.lowestPrice,
    getCurrentListing: state => state.currentListing,

    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status, 
    role: (state) => state.role,
}
